import React, { useCallback, useEffect, useState } from "react";
import Lottie from "react-lottie";

const Animation = ({
	useAnimation = false,
	className = "",
	animationData = {},
}: {
	useAnimation: boolean;
	className: string;
	animationData: Record<string, unknown>;
}) => {
	const [animating, setAnimating] = useState(false);
	const onAnimationComplete = useCallback(() => setAnimating(false), []);

	useEffect(() => {
		// Adding a slight delay before showing the animation
		let timeoutID = 0;
		if (useAnimation) {
			timeoutID = window.setTimeout(() => setAnimating(true), 200);
		}
		return () => window.clearTimeout(timeoutID);
	}, [useAnimation]);

	const animationOptions = {
		loop: false,
		autoplay: true,
		animationData,
		rendererSettings: {
			className: className,
			preserveAspectRatio: "xMidYMid slice",
		},
	};

	return animating ? (
		<Lottie
			isClickToPauseDisabled
			isStopped={false}
			options={animationOptions}
			eventListeners={[{ eventName: "complete", callback: onAnimationComplete }]}
		/>
	) : null;
};

export default Animation;
